// Ask the browser to keep this origin's storage — "persistent" instead of the
// default "best-effort", which the browser may evict under storage pressure
// with no warning. Both device queues hold work that exists nowhere else until
// it uploads: the face-clock queue (biometric scans of an offline shift) and
// the main offline queue (scouting, spray, fert, drain readings, picks …).
// A cheap phone with a full disk is exactly where eviction happens, and an
// evicted queue reads to the operator as "my captures vanished overnight".
//
// Never prompts in Chrome / Safari (they grant or refuse silently on
// engagement / install); Firefox may show a one-time prompt. Never throws.
export async function requestPersistence(): Promise<boolean> {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) return false
  try {
    const already = await navigator.storage.persisted?.()
    if (already) return true
    return await navigator.storage.persist()
  } catch {
    return false
  }
}

// Ask at most once per page load — the answer cannot change mid-session, and a
// queue write is not the place to wait on it.
let asked = false
export function requestPersistenceOnce(): void {
  if (asked) return
  asked = true
  void requestPersistence()
}

/** Test seam: forget that we asked. */
export function _resetPersistenceAskForTests(): void {
  asked = false
}
